import { FilterEntity } from '@bingads-webui/filter-entity';

// `$filter` is an OData query option
export function convertFilterEntity2$filter(filterEntity) {
  return filterEntity ? FilterEntity.toOdata(filterEntity.query, filterEntity.odataOptions) : undefined;
}
